<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Expert Details</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <button type="submit" class="btn btn-warning btn-fill" @click="editExpert">Edit Expert</button>
        </div>
      </div>
      <div class="table-responsive" v-if="expert">
        <table class="table table-bordered table-light">
          <tr>
            <th>Id</th>
            <td>{{expert.expertId}}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{expert.name}}</td>
          </tr>
          <tr>
            <th>Biography</th>
            <td>{{expert.biography}}</td>
          </tr>
          <tr>
            <th>Interest Name</th>
            <td>{{expert.interestName}}</td>
          </tr>
          <tr>
            <th>Expertise</th>
            <td>{{expert.experties}}</td>
          </tr>
          <tr>
            <th>Areas of Expertise</th>
            <td>{{expert.areasofexpertise}}</td>
          <tr>
            <th class="align-content-center">Image</th>
            <td><img :src="expert.small_image" alt="expert-image" class="detail-thumbnail"></td>
          </tr>
          <tr>
            <th>Corp. Associations</th>
            <td>{{expert.csvCorpNames}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'ViewExpert',
    components: {
      LTable,
    },
    created (){
      this.$store.dispatch('GETSELECTEDEXPERT', this.$route.params.id).then(() =>{
        this.expert = this.selectedExpert;
      })

    },
    data () {
      return {
        expert: {}
      }
    },
    methods: {
      editExpert(){
        this.$router.push({ name: 'EditExpert', params: { id: this.expert.expertId}})
      },
    },
    computed: {...mapGetters([
        'selectedExpert'])
    }
  }
</script>

<style>
  th{
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Experts/ExpertDetails.vue